





import { Component, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'

// 该页面禁用于以 iframe 形式，嵌入别的页面

@Component
export default class ClassHeader extends ViewBase {
}
